document.addEventListener('DOMContentLoaded', () => {
  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const fill = entry.target;
        const percentage = fill.getAttribute('data-percentage');
        
        // Use a slight timeout to ensure CSS transition runs
        setTimeout(() => {
          fill.style.width = percentage + '%';
        }, 100);
        
        observer.unobserve(fill);
      }
    });
  }, {
    threshold: 0.2
  });

  const progressFills = document.querySelectorAll('.custom-mission__progress-fill');
  progressFills.forEach(el => observer.observe(el));
});
